import { render, staticRenderFns } from "./WorkshopForm.vue?vue&type=template&id=67b96862&scoped=true&"
import script from "./WorkshopForm.vue?vue&type=script&lang=ts&"
export * from "./WorkshopForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b96862",
  null
  
)

export default component.exports